// Tela única CLP → Cartão → Sensor (rota /devices, restrita a Gestor).
import { DeviceManager } from "@/features/devices/manager";

export function DeviceManagerPage() {
  return <DeviceManager />;
}
